import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#0AA1F4'
        d='M12.359 13.045a6.667 6.667 0 111.102-1.218L11.334 8h2a5.334 5.334 0 10-1.64 3.848l.665 1.197z'
      ></path>
    </svg>
  )
}

export default Icon
